<div class="icon-wrapper cursor-pointer" #parent
  [ngClass]="{'border-brand border-width-2': !hideBorder, 'opacity-6 cursor-default': isDisabled}"
  (mouseover)="changeIconDropdown(imgDrop, parent, true, isDisabled)"
  (mouseout)="changeIconDropdown(imgDrop, parent, false, isDisabled)">
  <img
    #imgDrop
    [src]="defaultGrayColor ? imgDropdownGray : imgDropdown"
    class="rotate-90" alt="">
</div>
